import React, { useState } from "react";
import "./Header.css";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  return (
    <header className="header">
      <div className="header-container">

        <div className="logo-section">
          <img
            src="/images/prod-header/logo-vd.png"
            alt="Latpay Logo"
            className="logo"
          />
        </div>

        {/* RIGHT: EVERYTHING */}
        <div className="right-section">

          <img
            src="/images/prod-header/25years.png"
            alt="25 Years"
            className="anniversary"
          />

          <nav className="nav desktop-only">
            <a href="https://latpay.com/" target="_blank" >Solutions</a>
            <a href="https://latpay.com/" target="_blank" >Partners</a>
            <a href="https://latpay.com/" target="_blank" >Company</a>
            <a href="https://latpay.com/" target="_blank" >Resources</a>
          </nav>

          <div className="search-box desktop-only">
            <span className="search-icon">🔍︎</span>
            <input type="text" placeholder="Searching" />
          </div>

          {/* HAMBURGER ICON */}
          <div
            className="hamburger mobile-only"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            ☰
          </div>

        </div>

      </div>
      {/* MOBILE DROPDOWN */}
      {menuOpen && (
        <div className="mobile-menu">
          <a href="https://latpay.com/" target="_blank" >Solutions</a>
            <a href="https://latpay.com/" target="_blank" >Partners</a>
            <a href="https://latpay.com/" target="_blank" >Company</a>
            <a href="https://latpay.com/" target="_blank" >Resources</a>

          <div className="mobile-search">
            🔍︎
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;